import { useRouter } from "next/router";
import { useEffect } from "react";

import { useAuthContext } from "src/auth/hooks/useAuthContext";
import { shouldPreserveRedirectPath } from "src/auth/utils/postLoginRedirect";

type UserBoundaryProps = {
  redirect?: boolean;
};

export const UserBoundary: React.FC<UserBoundaryProps> = ({ children, redirect = true }) => {
  const { status } = useAuthContext();
  const router = useRouter();

  useEffect(() => {
    if ((status === "unauthenticated" || status === "needPracticeDoctorSelection") && redirect) {
      router.push({
        pathname: "/sign-in",
        query: shouldPreserveRedirectPath(router.asPath) ? { redirect: router.asPath } : undefined,
      });
    }
  }, [status, router, redirect]);

  return status === "authenticated" ? <>{children}</> : null;
};
